import _classCallCheck from "/home/runner/work/mozio-web/mozio-web/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/esm/classCallCheck.js";
import _createClass from "/home/runner/work/mozio-web/mozio-web/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/esm/createClass.js";
import "./chunk-PXG64RU4.js"; // src/subscribable.ts

var Subscribable = /*#__PURE__*/function () {
  function Subscribable() {
    _classCallCheck(this, Subscribable);

    this.listeners = /* @__PURE__ */new Set();
    this.subscribe = this.subscribe.bind(this);
  }

  return _createClass(Subscribable, [{
    key: "subscribe",
    value: function subscribe(listener) {
      var _this = this;

      this.listeners.add(listener);
      this.onSubscribe();
      return function () {
        _this.listeners.delete(listener);

        _this.onUnsubscribe();
      };
    }
  }, {
    key: "hasListeners",
    value: function hasListeners() {
      return this.listeners.size > 0;
    }
  }, {
    key: "onSubscribe",
    value: function onSubscribe() {}
  }, {
    key: "onUnsubscribe",
    value: function onUnsubscribe() {}
  }]);
}();

export { Subscribable };